package com.trevorwiebe.timesheet.core.domain.model

import com.trevorwiebe.timesheet.core.domain.dto.RateDto

data class Rate(
    val id: String,
    val description: String,
    val userFacing: Boolean,
    val defaultRate: Boolean,
    val rateCode: String,
    val overtimeRateCode: String = ""
) {
    val label: String get() = description
}

fun RateDto.toRate(): Rate {
    return Rate(
        id = id,
        description = description,
        userFacing = userFacing,
        defaultRate = defaultRate,
        rateCode = rateCode,
        overtimeRateCode = overtimeRateCode
    )
}